{
    "ClientDataGridColumns": [

        {
            "display": "true",
            "ui_columnname": "action",
            "db_columnname": "modifiedFlag",
            "datatype": "char",
            "mappingkey": "modifiedFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "true",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "firm ROEID",
            "db_columnname": "firmROEID",
            "datatype": "String",
            "mappingkey": "firmROEID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "symbol",
            "db_columnname": "symbol",
            "datatype": "String",
            "mappingkey": "symbol",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "type",
            "db_columnname": "type",
            "datatype": "String",
            "mappingkey": "type",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Event Type",
            "db_columnname": "eventType",
            "datatype": "String",
            "mappingkey": "eventType",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Date",
            "db_columnname": "reportDate",
            "datatype": "Date",
            "mappingkey": "reportDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Group",
            "db_columnname": "groupName",
            "datatype": "String",
            "mappingkey": "groupName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "failure Code",
            "db_columnname": "failureCode",
            "datatype": "String",
            "mappingkey": "failureCode",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "failure Description",
            "db_columnname": "failureDescription",
            "datatype": "String",
            "mappingkey": "failureDescription",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Actual Value",
            "db_columnname": "actualValue",
            "datatype": "String",
            "mappingkey": "actualValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Suggested Value",
            "db_columnname": "suggestedValue",
            "datatype": "String",
            "mappingkey": "suggestedValue",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "order ID",
            "db_columnname": "orderID",
            "datatype": "String",
            "mappingkey": "orderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "order Date",
            "db_columnname": "orderKeyDate",
            "datatype": "String",
            "mappingkey": "orderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Side",
            "db_columnname": "side",
            "datatype": "String",
            "mappingkey": "side",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Price",
            "db_columnname": "price",
            "datatype": "Float",
            "mappingkey": "price",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Quantity",
            "db_columnname": "quantity",
            "datatype": "Int",
            "mappingkey": "quantity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "destination",
            "db_columnname": "destination",
            "datatype": "String",
            "mappingkey": "destination",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "routed Order ID",
            "db_columnname": "routedOrderID",
            "datatype": "String",
            "mappingkey": "routedOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Parent Order ID",
            "db_columnname": "parentOrderID",
            "datatype": "String",
            "mappingkey": "parentOrderID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Parent Order Date",
            "db_columnname": "parentOrderKeyDate",
            "datatype": "String",
            "mappingkey": "parentOrderKeyDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdowntype": "singleselect",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "session",
            "db_columnname": "session",
            "datatype": "String",
            "mappingkey": "session",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "trade Id",
            "db_columnname": "tradeId",
            "datatype": "String",
            "mappingkey": "tradeId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "quote Id",
            "db_columnname": "quoteId",
            "datatype": "String",
            "mappingkey": "quoteId",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "quote MPID",
            "db_columnname": "quoteMPID",
            "datatype": "String",
            "mappingkey": "quoteMPID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "event Timestamp",
            "db_columnname": "eventTimestamp",
            "datatype": "String",
            "mappingkey": "eventTimestamp",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "manual Flag",
            "db_columnname": "manualFlag",
            "datatype": "boolean",
            "mappingkey": "manualFlag",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Time In Force",
            "db_columnname": "timeInForce",
            "datatype": "String",
            "mappingkey": "timeInForce",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Sender IMID",
            "db_columnname": "senderIMID",
            "datatype": "String",
            "mappingkey": "senderIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "Handlling Instructions",
            "db_columnname": "handlingInstructions",
            "datatype": "String",
            "mappingkey": "handlingInstructions",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "false",
            "ui_columnname": "severity",
            "db_columnname": "severity",
            "datatype": "String",
            "mappingkey": "severity",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CAT Submitter ID",
            "db_columnname": "CATSubmitterID",
            "datatype": "String",
            "mappingkey": "CATSubmitterID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "CAT Reporter ID",
            "db_columnname": "CATReporterIMID",
            "datatype": "String",
            "mappingkey": "CATReporterIMID",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "file Name",
            "db_columnname": "fileName",
            "datatype": "String",
            "mappingkey": "fileName",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "status",
            "db_columnname": "status",
            "datatype": "String",
            "mappingkey": "status",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "create Date",
            "db_columnname": "createDate",
            "datatype": "String",
            "mappingkey": "createDate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "last Update",
            "db_columnname": "lastUpdate",
            "datatype": "String",
            "mappingkey": "lastUpdate",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        },
        {
            "display": "true",
            "ui_columnname": "user",
            "db_columnname": "user",
            "datatype": "String",
            "mappingkey": "user",
            "dropdown": "NO",
            "isdefault": "false",
            "disabled": "false",
            "value": "",
            "dropdownvalue": ""
        }
        
    ],
    "MassCorrectionOrderFieldList": [
        {"display": "true", "ui_columnname": "Event Type", "db_columnname": "EventType", "datatype": "String", "mappingkey": "EventType", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Symbol", "db_columnname": "Symbol", "datatype": "String", "mappingkey": "Symbol", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Order ID", "db_columnname": "OrderID", "datatype": "String", "mappingkey": "OrderID", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Order Date Time", "db_columnname": "OrderDateTime", "datatype": "String", "mappingkey": "OrderDateTime", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "placeholder": "yyyymmdd hh:mm:ss"},
        {"display": "true", "ui_columnname": "Side", "db_columnname": "BuySellCode", "datatype": "String", "mappingkey": "BuySellCode", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Order Quantity", "db_columnname": "quantity", "datatype": "String", "mappingkey": "quantity", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "placeholder": "Numeric", "regularexpressions": ["^\\d+$"]},
        {"display": "true", "ui_columnname": "Limit Price", "db_columnname": "LimitPrice", "datatype": "String", "mappingkey": "LimitPrice", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "placeholder": "Numeric", "regularexpressions": ["^\\d*(\\.\\d+)?$"]},
        {"display": "true", "ui_columnname": "Price Type", "db_columnname": "PriceType", "datatype": "String", "mappingkey": "PriceType", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Customer ID", "db_columnname": "CustomerID", "datatype": "String", "mappingkey": "CustomerID", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Received From MPID", "db_columnname": "ReceivedFromMPID", "datatype": "String", "mappingkey": "ReceivedFromMPID", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Receive Method", "db_columnname": "ReceiveMethod", "datatype": "String", "mappingkey": "ReceiveMethod", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Trading Session Code", "db_columnname": "TradingSessionCode", "datatype": "String", "mappingkey": "TradingSessionCode", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Special Handling Code", "db_columnname": "SplHandlingCode", "datatype": "String", "mappingkey": "SplHandlingCode", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Ext Destination", "db_columnname": "ExtDestination", "datatype": "String", "mappingkey": "ExtDestination", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""}
    ],
    "MassCorrectionRouteFieldList": [
        {"display": "true", "ui_columnname": "Event Type", "db_columnname": "EventType", "datatype": "String", "mappingkey": "EventType", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Symbol", "db_columnname": "Symbol", "datatype": "String", "mappingkey": "Symbol", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Order ID", "db_columnname": "OrderID", "datatype": "String", "mappingkey": "OrderID", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Order Date Time", "db_columnname": "OrderDateTime", "datatype": "String", "mappingkey": "OrderDateTime", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "placeholder": "yyyymmdd hh:mm:ss"},
        {"display": "true", "ui_columnname": "Side", "db_columnname": "BuySellCode", "datatype": "String", "mappingkey": "BuySellCode", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Order Quantity", "db_columnname": "Quantity", "datatype": "String", "mappingkey": "Quantity", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "placeholder": "Numeric", "regularexpressions": ["^\\d+$"]},
        {"display": "true", "ui_columnname": "Limit Price", "db_columnname": "LimitPrice", "datatype": "String", "mappingkey": "LimitPrice", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "placeholder": "Numeric", "regularexpressions": ["^\\d*(\\.\\d+)?$"]},
        {"display": "true", "ui_columnname": "Price Type", "db_columnname": "PriceType", "datatype": "String", "mappingkey": "PriceType", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Trading Session Code", "db_columnname": "TradingSessionCode", "datatype": "String", "mappingkey": "TradingSessionCode", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Special Handling Code", "db_columnname": "SplHandlingCode", "datatype": "String", "mappingkey": "SplHandlingCode", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Ext Destination", "db_columnname": "ExtDestination", "datatype": "String", "mappingkey": "ExtDestination", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""}
    ],
    "MassCorrectionTradeFieldList": [
        {"display": "true", "ui_columnname": "Event Type", "db_columnname": "EventType", "datatype": "String", "mappingkey": "EventType", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Symbol", "db_columnname": "Symbol", "datatype": "String", "mappingkey": "Symbol", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Order ID", "db_columnname": "OrderID", "datatype": "String", "mappingkey": "OrderID", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Order Date Time", "db_columnname": "OrderDateTime", "datatype": "String", "mappingkey": "OrderDateTime", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "placeholder": "yyyymmdd hh:mm:ss"},
        {"display": "true", "ui_columnname": "Side", "db_columnname": "BuySellCode", "datatype": "String", "mappingkey": "BuySellCode", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Order Quantity", "db_columnname": "Quantity", "datatype": "String", "mappingkey": "Quantity", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "placeholder": "Numeric", "regularexpressions": ["^\\d+$"]},
        {"display": "true", "ui_columnname": "Price", "db_columnname": "Price", "datatype": "String", "mappingkey": "Price", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "placeholder": "Numeric", "regularexpressions": ["^\\d*(\\.\\d+)?$"]},
        {"display": "true", "ui_columnname": "Customer ID", "db_columnname": "CustomerID", "datatype": "String", "mappingkey": "CustomerID", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Receive Method", "db_columnname": "ReceiveMethod", "datatype": "String", "mappingkey": "ReceiveMethod", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""}
    ],
    "MassCorrectionAllocationFieldList": [
        {"display": "true", "ui_columnname": "Event Type", "db_columnname": "EventType", "datatype": "String", "mappingkey": "EventType", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Symbol", "db_columnname": "Symbol", "datatype": "String", "mappingkey": "Symbol", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Order ID", "db_columnname": "OrderID", "datatype": "String", "mappingkey": "OrderID", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Side", "db_columnname": "BuySellCode", "datatype": "String", "mappingkey": "BuySellCode", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Order Quantity", "db_columnname": "quantity", "datatype": "String", "mappingkey": "quantity", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "placeholder": "Numeric", "regularexpressions": ["^\\d+$"]},
        {"display": "true", "ui_columnname": "Price", "db_columnname": "price", "datatype": "String", "mappingkey": "price", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": "", "placeholder": "Numeric", "regularexpressions": ["^\\d*(\\.\\d+)?$"]},
        {"display": "true", "ui_columnname": "Customer ID", "db_columnname": "CustomerID", "datatype": "String", "mappingkey": "CustomerID", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""},
        {"display": "true", "ui_columnname": "Receive Method", "db_columnname": "ReceiveMethod", "datatype": "String", "mappingkey": "ReceiveMethod", "dropdown": "NO", "isdefault": "false", "disabled": "false", "value": "", "dropdownvalue": ""}
    ]
}